import type * as Types from 'app/types/graphql';

import { VariantPriceSelectFragmentDoc } from '../fragments/variantPrice.generated';
import { useMutation, type UseMutationOptions } from '@tanstack/react-query';
import { appFetcher } from '~/api/utils/gatewayClient';
export type VariantPriceUpdateMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  input: Types.UpdateVariantPriceInput;
}>;

export type VariantPriceUpdateMutationResponse = {
  variantPriceUpdate?: Types.Maybe<
    Pick<
      Types.VariantPrice,
      'id' | 'baseID' | 'handle' | 'status' | 'title' | 'redirectURL' | 'sourceProductBaseID'
    >
  >;
};

export const VariantPriceUpdateDocument = `
    mutation VariantPriceUpdate($id: ID!, $input: UpdateVariantPriceInput!) {
  variantPriceUpdate(id: $id, input: $input) {
    ...VariantPriceSelect
  }
}
    ${VariantPriceSelectFragmentDoc}`;

export const useVariantPriceUpdateMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    VariantPriceUpdateMutationResponse,
    TError,
    VariantPriceUpdateMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    VariantPriceUpdateMutationResponse,
    TError,
    VariantPriceUpdateMutationVariables,
    TContext
  >(
    ['VariantPriceUpdate'],
    (variables?: VariantPriceUpdateMutationVariables) =>
      appFetcher<VariantPriceUpdateMutationResponse, VariantPriceUpdateMutationVariables>(
        VariantPriceUpdateDocument,
        variables,
      )(),
    options,
  );
};

useVariantPriceUpdateMutation.getKey = () => ['VariantPriceUpdate'];
